export default class DatabaseEntities {
  static readonly ACCESS = "access";
  static readonly APPOINTMENTS = "appointments";
  static readonly ATTACHMENTS = "attachments";
  static readonly AUTH = "auth";
  static readonly BUNDLES = "bundles";
  static readonly ULTRA_BUNDLES = "bundles/ultra";
  static readonly BUNDLE_ITEMS = "bundleItems";
  static readonly CATEGORIES = "categories";
  static readonly CLIENTS = "clients";
  static readonly CLIENT_LEVELS = "levels";
  static readonly CLIENT_TYPES = "types";
  static readonly CONTRACTORS = "contractors";
  static readonly EMAIL_TEMPLATES = "emailTemplates";
  static readonly EMPLOYES = "employees";
  static readonly EMPLOYEE_ROLES = "employees/roles";
  static readonly ERRORS = "errors";
  static readonly ESTIMATES = "estimates";
  static readonly FAQS = "faqs";
  static readonly GALLERY = "gallery";
  static readonly IMAGES = "images";
  static readonly LOGS = "logs";
  static readonly MESSAGES = "messages";
  static readonly PAYMENT_METHODS = "paymentMethods";
  static readonly PERMISSIONS = "permissions";
  static readonly PRODUCTS = "products";
  static readonly PROJECTS = "projects";
  static readonly PROJECT_TYPES = "projectTypes";
  static readonly REQUESTS = "requests";
  static readonly REVIEWS = "reviews";
  static readonly ROLES = "roles";
  static readonly PLACES = "places";
  static readonly SERVICE_TYPES = "serviceTypes";
  static readonly SERVICES = "services";
  static readonly SESSIONS = "sessions";
  static readonly STAGED_PAYMENTS = "stagedPayments";
  static readonly STATUS = "status";
  static readonly TAGS = "tags";
  static readonly TAG_GROUPS = "tagGroups";
  static readonly TEAMS = "teams";
  static readonly TEAM_MEMBERS = "members";
  static readonly USERS = "users";
  static readonly VENDORS = "vendors";
}
